import React from "react";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import FormTextField from "../../../../../core/ui/FormTextField";
import Button from "../../../../../core/ui/Button";
import TabGroup from "../../../../../core/ui/TabGroup";

const LEGAL_STATUS_OPTIONS = [
  "Individuals",
  "Sole Proprietorship",
  "Corporation (Registered in the Philippines)",
  "Corporation (Registered Outside the Philippines)",
  "Partnership",
  "Trust",
  "Other",
];

export default function CompanyBusinessDetailsStep({
  form,
  setForm,
  setEmployeeModalOpen,
  handleChange,
  errors = {},
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Grid container sx={{ maxWidth: "778px", gap: "24px" }}>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Registered Name of Engaging Client"
            required={true}
            value={form.registeredName}
            onChange={handleChange("registeredName")}
            placeholder="SJC NBT Polas Inc."
            maxwidth="377px"
            error={!!errors.registeredName}
            errorMessage={errors.registeredName}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Industry"
            required={true}
            value={form.industry}
            onChange={handleChange("industry")}
            placeholder="IT"
            maxwidth="377px"
            error={!!errors.industry}
            errorMessage={errors.industry}
          />
        </Grid>
      </Grid>
      <Box>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 500, color: "#313131", mb: 1.5 }}
        >
          Legal Status <span style={{ color: "#d32f2f" }}>*</span>
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup
            value={form.legalStatus}
            onChange={handleChange("legalStatus")}
          >
            {LEGAL_STATUS_OPTIONS.map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={
                  <Radio
                    size="small"
                    sx={{
                      color: "#003F2E",
                      "&.Mui-checked": { color: "#003F2E" },
                    }}
                  />
                }
                label={
                  <Typography sx={{ fontSize: "14px", color: "#313131" }}>
                    {option}
                  </Typography>
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
        {form.legalStatus === "Other" && (
          <FormTextField
            value={form.othersSpecify}
            placeHolder="Please Specify"
            maxwidth="372px"
            onChange={handleChange("othersSpecify")}
            error={!!errors.othersSpecify}
            errorMessage={errors.othersSpecify}
          />
        )}
      </Box>
      <Box>
        <FormTextField
          label="Address"
          required={true}
          value={form.companyAddress}
          onChange={handleChange("companyAddress")}
          disabled={form.sameAddressAsContact}
          multiline
          rows={3}
          placeholder="Hello!"
          maxwidth="778px"
          error={!!errors.companyAddress}
          errorMessage={errors.companyAddress}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={form.sameAddressAsContact}
              onChange={handleChange("sameAddressAsContact")}
              size="small"
              sx={{ color: "#003F2E", "&.Mui-checked": { color: "#003F2E" } }}
            />
          }
          label={
            <Typography sx={{ fontSize: "14px", color: "#313131" }}>
              Same address in contact info.
            </Typography>
          }
          sx={{ mt: 1 }}
        />
      </Box>
      <Grid container sx={{ maxWidth: "778px", gap: "24px" }}>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Addressee on Proposals"
            required={true}
            value={form.addresseeOnProposals}
            onChange={handleChange("addresseeOnProposals")}
            placeholder="Mr./Mrs."
            maxwidth="377px"
            error={!!errors.addresseeOnProposals}
            errorMessage={errors.addresseeOnProposals}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Position"
            required={true}
            value={form.proposalPosition}
            onChange={handleChange("proposalPosition")}
            maxwidth="377px"
            error={!!errors.proposalPosition}
            errorMessage={errors.proposalPosition}
          />
        </Grid>
      </Grid>
      <Box>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 600, color: "#283745", mb: 2 }}
        >
          For referral?
        </Typography>
        <Box sx={{ mb: 2 }}>
          <TabGroup
            tabLabels={["Yes", "No"]}
            activeTab={form.forReferral ? 0 : 1}
            handleTabChange={(e, newValue) => {
              setForm({ ...form, forReferral: newValue === 0 });
            }}
          />
        </Box>
        {form.forReferral && (
          <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", mt: 1 }}>
            <Button
              variant="primary"
              sx={{
                height: 40,
                fontWeight: 600,
                maxWidth: "135px",
                fontStyle: "semi-bold",
              }}
              onClick={() => setEmployeeModalOpen(true)}
            >
              Refer to
            </Button>
            <FormTextField
              disabled
              value={form.referToName || ""}
              placeholder="Select here..."
              maxwidth="361px"
              error={!!errors.referTo}
              errorMessage={errors.referTo}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}